import useAlert from '../useAlert'
import styles from './alert.module.scss'

interface Alert {
  title?: string
  jsonData?: string
  children?: React.ReactNode
}

const Alert = (props: Alert) => {
  const { title, jsonData, children } = props

  const { debug } = useAlert()

  return (
    <div className={styles.alertRoot}>
      {title && <h1>{title}</h1>}
      {children}
      {debug && jsonData && <pre>{JSON.stringify(jsonData, null, 2)}</pre>}
    </div>
  )
}

export default Alert
